import React from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import logo from "../../assets/images/2-e1687874111881.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
                    {/* logo */}
                    <motion.img 
              src={logo}
              alt="Luxury Car Rentals" 
              className="h-16 mb-4 object-contain mx-auto"
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
              />
        <div className="flex flex-row justify-between gap-8">
          {/* About Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-bold mb-4">About Us</h2>
            <p className="text-gray-400 mb-4">
              We provide premium transfer services across Mykonos island with reliable
              and comfortable transportation for all your needs.
            </p>
            <div className="flex space-x-4">
              <motion.a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <FaFacebookF />
              </motion.a>
              <motion.a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <FaTwitter />
              </motion.a>
              <motion.a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <FaInstagram />
              </motion.a>
              <motion.a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                whileHover={{ scale: 1.2, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <FaLinkedinIn />
              </motion.a>
            </div>
          </motion.div>


          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <h2 className="text-xl font-bold mb-4">Contact Us</h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-primary-light mt-1 mr-3" />
                <span className="text-gray-400">Epar. Od. Mykonos 846 00, Greece</span>
              </li>
              <li className="flex items-center">
                <FaPhoneAlt className="text-primary-light mr-3" />
                <a href="tel:+306941419012" className="text-gray-400 hover:text-white transition-colors duration-300">+30 69 41419012</a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-primary-light mr-3" />
                <a href="mailto:nleont@gmail.com" className="text-gray-400 hover:text-white transition-colors duration-300">nleont@gmail.com</a>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>

      <motion.div 
        className="w-full h-px bg-gray-700"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      />

      <motion.div 
        className="py-6 text-center text-gray-400 text-sm"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        MYKONOS TRANSFER © {currentYear} POWERED AND CREATED BY{' '}
        <motion.a 
          href="https://create-website.gr" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white hover:text-primary-light transition-colors duration-300"
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.2 }}
        >
          CREATE-WEBSITE.GR
        </motion.a>
      </motion.div>
    </footer>
  );
};

export default Footer;
